// Centralized temporary media. Replace URLs here when real Strollee assets arrive.
export const media = {
  heroMedia: {
    url: "https://images.unsplash.com/photo-1758919014355-5dfd705bf6a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzMzN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYWJ5JTIwY2FycmlhZ2UlMjB1cmJhbnxlbnwwfHx8fDE3OTA4NzE3NDd8MA&ixlib=rb-4.1.0&q=85",
    alt: "Strollee S1 premium modular stroller on a sunlit urban promenade",
  },
  heroBackups: [
    {
      id: "hero_backup_1",
      url: "https://images.unsplash.com/photo-1663579170170-169a1ee8b9be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzdHJvbGxlciUyMHVyYmFuJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MDg3MTczMXww&ixlib=rb-4.1.0&q=85",
      alt: "Stroller in a modern architectural park setting",
    },
    {
      id: "hero_backup_2",
      url: "https://images.unsplash.com/photo-1598637349891-151ec358de71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzdHJvbGxlciUyMHVyYmFuJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MDg3MTczMXww&ixlib=rb-4.1.0&q=85",
      alt: "Stroller on a sunny city waterfront boardwalk",
    },
    {
      id: "hero_backup_3",
      url: "https://images.unsplash.com/photo-1784751722840-471e603b467f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxiYWJ5JTIwc3Ryb2xsZXIlMjBvdXRkb29yfGVufDB8fHx8MTc5MDg3MTc0MHww&ixlib=rb-4.1.0&q=85",
      alt: "Detail view of premium stroller materials in sunlight",
    },
    {
      id: "hero_backup_4",
      url: "https://images.unsplash.com/photo-1539893147390-a9c1d69f00be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxzdHJvbGxlciUyMHBhcmslMjBzdW5ueXxlbnwwfHx8fDE3OTA4NzE3MzV8MA&ixlib=rb-4.1.0&q=85",
      alt: "Sunlit outdoor lifestyle stroller shot",
    },
  ],
};

// Brand assets (user-provided)
export const brandAssets = {
  logoDark: {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_strollee-s1-premiere/artifacts/o0uz1va9_logo.png",
    alt: "Strollee",
  },
  logoLight: {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_strollee-s1-premiere/artifacts/oexl0zr7_logo-light.png",
    alt: "Strollee",
  },
  strollerSilhouette: {
    url: "/media/strollee-silhouette.png",
    alt: "",
  },
  footerMotion: {
    webm: "/media/strollee-rotate.webm",
    mp4: "/media/strollee-rotate.mp4",
    alt: "Strollee S1 rotating in a dark studio",
  },
};

// V1.2 hero — real Strollee lifestyle photo (user-provided)
export const heroMediaV12 = {
  url: "/media/hero-2.png",
  alt: "Strollee S1 on a family stroll — parent pushing, child riding along, dog in the bassinet",
};

export const heroCopy = {  eyebrow: "Strollee S1",
  headlineLines: ["One stroller.", "Every stage of", "family life."],
  support:
    "From newborn to double, jogger and wagon — one system built to grow with your family.",
  primaryCta: "Build my Strollee",
  secondaryCta: "Explore S1",
  proof: ["40+ configurations", "65L removable storage", "All-terrain suspension"],
};

// Phase 02 — Find Your Strollee: family scenarios (not physical modes).
export const selectorCopy = {
  eyebrow: "Find your Strollee",
  headlineLines: ["Made for every way", "your family moves."],
  support:
    "Start with where your family is today. Strollee is designed to adapt as life changes.",
  exploreCta: "Explore this setup",
  quizHint: "Not sure where to start?",
  quizLink: "Find My Setup",
};

export const scenarioData = [
  {
    id: "newborn",
    label: "Newborn",
    title: "Ready from day one.",
    copy: "A comfortable starting setup designed for your first days and everything that follows.",
    image: {
      url: "https://images.unsplash.com/photo-1773672268537-21e349bc7273?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwcmFtJTIwYmFzc2luZXRFZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85",
      alt: "Strollee S1 with bassinet in a calm waterfront setting",
      position: "center 72%",
    },
  },
  {
    id: "everyday",
    label: "Everyday",
    title: "Built for every day.",
    copy: "One adaptable setup for errands, walks, travel and the rhythm of everyday family life.",
    image: {
      url: "https://images.unsplash.com/photo-1663579170170-169a1ee8b9be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzdHJvbGxlciUyMHVyYmFuJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MDg3MTczMXww&ixlib=rb-4.1.0&q=85",
      alt: "Strollee S1 on a city sidewalk during a daily walk",
      position: "center 68%",
    },
  },
  {
    id: "growing-family",
    label: "Growing Family",
    title: "Ready when one becomes two.",
    copy: "Start with what you need today and adapt the same Strollee system as your family grows.",
    image: {
      url: "https://images.unsplash.com/photo-1598637349891-151ec358de71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzdHJvbGxlciUyMHVyYmFuJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MDg3MTczMXww&ixlib=rb-4.1.0&q=85",
      alt: "Strollee setup with child aboard on a city boardwalk",
    },
  },
  {
    id: "two-kids",
    label: "Two Kids",
    title: "More room for family.",
    copy: "A setup designed to move two children comfortably without starting again with another stroller.",
    image: {
      url: "https://images.unsplash.com/photo-1741990811736-81fd08f449e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxqb2dnaW5nJTIwc3Ryb2xsZXJ8ZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85",
      alt: "Two Strollee setups moving side by side along the waterfront",
    },
  },
  {
    id: "active",
    label: "Active",
    title: "Made to move.",
    copy: "For faster days, longer walks and an active family routine.",
    image: {
      url: "https://images.pexels.com/photos/19444952/pexels-photo-19444952.jpeg?auto=compress&cs=tinysrgb&w=1920",
      alt: "Active family walking with the Strollee on a sunny country path",
    },
  },
  {
    id: "adventure",
    label: "Adventure",
    title: "Go beyond the everyday.",
    copy: "Built for bigger days, more gear and wherever family life takes you.",
    image: {
      url: "https://images.unsplash.com/photo-1733380005522-b8d76ce49d13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NTYxOTF8MHwxfHNlYXJjaHw0fHxzdHJvbGxlciUyMHBhcmt8ZW58MHx8fHwxNzkwODczNDAwfDA&ixlib=rb-4.1.0&q=85",
      alt: "Family weekend adventure with the Strollee across open parkland",
    },
  },
];

export const defaultScenarioId = "everyday";

// V1.3 — Community / launch momentum (V1.3 only). Stat + quote sourced from presale.strollee.com.
export const communityCopyV13 = {
  eyebrow: "The Strollee community",
  headlineLines: ["10,000+ families", "already following the journey."],
  support:
    "Families around the world are already following Strollee toward launch — and helping shape what comes next.",
  statNumber: "10,000+",
  statLabel: "families on the launch list",
  quote:
    "Our daughter was always crying when we put her in a stroller. We tried a strollee s1 and now the stroller is one of her happiest places.",
  quoteAttribution: "Strollee family — shared on the Strollee presale",
  cta: "Join the journey",
};

export const communityMediaV13 = [
  {
    id: "c1",
    url: "/media/hero-v12.webp",
    alt: "Family out with the Strollee S1",
    width: "w-[38%]",
    height: "h-[340px] lg:h-[400px]",
  },
  {
    id: "c2",
    url: "https://images.unsplash.com/photo-1773672268537-21e349bc7273?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwcmFtJTIwYmFzc2luZXRFZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85",
    alt: "Early family walk with the Strollee",
    position: "center 70%",
    width: "w-[26%]",
    height: "h-[300px] lg:h-[340px]",
  },
  {
    id: "c3",
    url: "https://images.unsplash.com/photo-1598637349891-151ec358de71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzdHJvbGxlciUyMHVyYmFuJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MDg3MTczMXww&ixlib=rb-4.1.0&q=85",
    alt: "Strollee out in the city",
    width: "w-[30%]",
    height: "h-[360px] lg:h-[420px]",
  },
  {
    id: "c4",
    url: "https://images.unsplash.com/photo-1733380005522-b8d76ce49d13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NTYxOTF8MHwxfHNlYXJjaHw0fHxzdHJvbGxlciUyMHBhcmt8ZW58MHx8fHwxNzkwODczNDAwfDA&ixlib=rb-4.1.0&q=85",
    alt: "Weekend outdoors with the Strollee",
    width: "w-[34%]",
    height: "h-[320px] lg:h-[380px]",
  },
  {
    id: "c5",
    url: "https://images.pexels.com/photos/19444952/pexels-photo-19444952.jpeg?auto=compress&cs=tinysrgb&w=1920",
    alt: "Family day out with the Strollee",
    width: "w-[28%]",
    height: "h-[300px] lg:h-[360px]",
  },
];

// V1.3 Refinement 13 — Community cards rail (V1.3 only)
// NOTE: names, cities and captions are PLACEHOLDERS until real UGC is supplied.
export const communityCardsV13 = [
  {
    id: "mara",
    name: "Mara",
    city: "Lisbon",
    mode: "Double",
    caption: "Double mode for the twins — finally one stroller, not two.",
    media: { type: "image", url: "/media/hero.png", alt: "Mara out with the Strollee S1", position: "center 30%" },
  },
  {
    id: "jonas",
    name: "Jonas",
    city: "Copenhagen",
    mode: "Bassinet → Seat",
    caption: "Watched it change modes in the hallway. Still not over it.",
    media: { type: "video", mp4: "/media/strollee-modularity.mp4", webm: "/media/strollee-modularity.webm", poster: "/media/strollee-modularity-poster.jpg", alt: "Strollee S1 transforming between modes" },
  },
  {
    id: "elena",
    name: "Elena",
    city: "Milan",
    mode: "Bassinet",
    caption: "First walk home from the hospital. She slept the whole way.",
    media: { type: "image", url: "https://images.unsplash.com/photo-1773672268537-21e349bc7273?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwcmFtJTIwYmFzc2luZXRFZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85", alt: "First walk with the Strollee bassinet", position: "center 70%" },
  },
  {
    id: "tom",
    name: "Tom",
    city: "Austin",
    mode: "Everyday",
    caption: "Seat up high at the café table. No more bending down to feed him.",
    media: { type: "video", mp4: "/media/award-seat-heights.mp4", webm: "/media/award-seat-heights.webm", poster: "/media/award-seat-heights-poster.jpg", alt: "Strollee S1 seat height adjusting", position: "center 40%" },
  },
  {
    id: "aisha",
    name: "Aisha",
    city: "London",
    mode: "Everyday",
    caption: "Errands, nursery run, park. One push and it just glides.",
    media: { type: "image", url: "https://images.unsplash.com/photo-1598637349891-151ec358de71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzdHJvbGxlciUyMHVyYmFuJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MDg3MTczMXww&ixlib=rb-4.1.0&q=85", alt: "Strollee out in the city" },
  },
  {
    id: "lukas",
    name: "Lukas",
    city: "Munich",
    mode: "Wagon",
    caption: "Weekend at the lake: two kids, towels, snacks — all in.",
    media: { type: "image", url: "https://images.unsplash.com/photo-1733380005522-b8d76ce49d13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NTYxOTF8MHwxfHNlYXJjaHw0fHxzdHJvbGxlciUyMHBhcmt8ZW58MHx8fHwxNzkwODczNDAwfDA&ixlib=rb-4.1.0&q=85", alt: "Weekend outdoors with the Strollee" },
  },
  {
    id: "sofia",
    name: "Sofia",
    city: "Barcelona",
    mode: "Jogger",
    caption: "Sunday run along the beach — she waves at every dog.",
    media: { type: "image", url: "https://images.pexels.com/photos/19444952/pexels-photo-19444952.jpeg?auto=compress&cs=tinysrgb&w=1920", alt: "Family day out with the Strollee" },
  },
];

export const communityShareCardV13 = {
  eyebrow: "Your turn",
  title: "Share yours",
  tag: "#strollee",
  copy: "Tag your Strollee moments — the best ones end up here.",
  cta: "Join the journey",
};

// V1.3 — Awards / credibility chapter (V1.3 only)
export const awardsCopyV13 = {
  eyebrow: "Recognized by design experts",
  headlineLines: ["Award-winning", "by design."],
  support:
    "Recognized by GOOD DESIGN and Core77 for rethinking how one stroller can adapt around real family life.",
  awards: [
    {
      id: "good-design",
      mark: "GOOD DESIGN",
      details: ["2025", "Children's Products"],
    },
    {
      id: "core77",
      mark: "Core77 Design Awards",
      details: ["2025", "Transportation & Mobility", "Professional Winner"],
    },
  ],
  trustLine: "4+ years designing & engineering Strollee",
  quotes: [
    "The 7 adjustable seat heights bring comfort and connection.",
    "The skateboard accessory for the older sibling is the coolest thing we've seen.",
    "It is funny to see parents with fancy strollers going around with a blanket on top to create shade.",
  ],
  quoteAttribution: "Jury comments — GOOD DESIGN & Core77 Design Awards",
  productMedia: {
    url: "/media/studio-newborn-cut.webp",
    alt: "Strollee S1 — award-winning stroller system",
  },
};

// V1.3 Refinement 12 — "The jury's verdict" evidence triptych (V1.3 only)
export const awardsVerdictV13 = {
  eyebrow: "Recognized by design experts",
  headlineLines: ["Awarded by the world’s", "leading design experts."],
  support:
    "GOOD DESIGN and Core77 jurors didn’t just award the S1 — they singled out the details that make daily life easier.",
  badges: [
    { id: "good-design", url: "/media/badge-good-design.png", alt: "GOOD DESIGN Award 2025", label: "GOOD DESIGN", meta: "2025 · Children’s Products" },
    { id: "core77", url: "/media/badge-core77.png", alt: "Core77 Design Awards 2025 Winner", label: "Core77 Design Awards", meta: "2025 · Winner" },
  ],
  verdicts: [
    {
      id: "seat-heights",
      award: "GOOD DESIGN",
      quoteBefore: "The ",
      highlight: "7 adjustable seat heights",
      quoteAfter: " bring comfort and connection: up for bonding and less strain on parents’ backs, low for the lunch table with zero fuss.",
      media: { type: "video", mp4: "/media/award-seat-heights.mp4", webm: "/media/award-seat-heights.webm", poster: "/media/award-seat-heights-poster.jpg", alt: "Strollee S1 seat moving through its seven heights", position: "center 40%" },
    },
    {
      id: "skateboard",
      award: "GOOD DESIGN",
      quoteBefore: "The ",
      highlight: "skateboard accessory for the older sibling",
      quoteAfter: " is the coolest thing we’ve seen. A simple, genius idea that reinvents a basic accessory.",
      media: { type: "image", url: "/media/award-skateboard.webp", alt: "Child riding the Strollee skateboard accessory", position: "center 60%" },
    },
    {
      id: "shade",
      award: "Core77",
      quoteBefore: "Parents with fancy strollers still throw a blanket on top for shade. Strollee has it ",
      highlight: "integrated neatly",
      quoteAfter: ". Super smart.",
      media: { type: "image", url: "/media/award-canopy.webp", alt: "Strollee S1 integrated canopy extended for shade", position: "center 55%" },
    },
  ],
  attribution: "Jury comments",
  footerStats: ["4+ years of design & engineering", "2 international design awards", "Jury-cited details, not marketing claims"],
  cta: "Safety & engineering",
};

// V1.3 — High-CRO value chapter "Too many strollers." (V1.3 only)
// NOTE: stat "3–4" is placeholder from presale messaging — VERIFY FINAL SOURCE BEFORE PRODUCTION.
export const valueCopyV13 = {
  eyebrow: "The problem with strollers",
  headlineLines: ["Too many strollers.", "Too much cost.", "Too much waste."],
  support:
    "Family needs change. Most strollers don’t. So parents often end up replacing or adding another one.",
  problemLabel: "The old cycle",
  consequences: ["More to buy", "More to store", "More to replace", "More waste"],
  statNumber: "3–4",
  statLabel: "strollers over the family journey",
  resolutionLabel: "The Strollee way",
  resolutionHeadline: ["One system.", "Built to evolve."],
  resolutionCopy:
    "From newborn to everyday, growing family, active use and more — adapt the system instead of starting over.",
  cta: "See how Strollee adapts",
};

// V1.3 Refinement 11 — "The ledger" comparison (V1.3 only)
export const valueLedgerV13 = {
  eyebrow: "The problem with strollers",
  headlineLines: ["Most families buy 3–4 strollers.", "You need one."],
  support:
    "Family needs change every year or two. Most strollers don’t — so parents keep buying, storing and replacing.",
  usualLabel: "The usual way",
  strolleeLabel: "The Strollee way",
  stages: [
    { id: "newborn", stage: "Newborn", buy: "Bassinet pram", mode: "Bassinet" },
    { id: "everyday", stage: "6 months +", buy: "Everyday stroller", mode: "Single" },
    { id: "second", stage: "Second child", buy: "Double stroller", mode: "Double" },
    { id: "active", stage: "Active & travel", buy: "Jogger / travel stroller", mode: "Jogger" },
  ],
  tally: ["4 purchases", "4 to store", "4 to resell or dump"],
  strolleeHeadline: "One system. Built to evolve.",
  strolleeCopy: "Adapt the system as life changes.",
  statNumber: "3–4",
  statLabel: "strollers over the family journey",
  cta: "See how Strollee adapts",
  video: {
    url: "/media/strollee-modularity.mp4",
    webmUrl: "/media/strollee-modularity.webm",
    posterUrl: "/media/strollee-modularity-poster.jpg",
    alt: "Strollee S1 transforming from bassinet to seat to wagon",
  },
};

export const valueProblemCards = [
  {
    id: "p1",
    label: "Newborn stroller",
    url: "https://images.unsplash.com/photo-1773672268537-21e349bc7273?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwcmFtJTIwYmFzc2luZXRFZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85",
    alt: "Generic newborn stroller",
    position: "center 70%",
  },
  {
    id: "p2",
    label: "Everyday stroller",
    url: "https://images.unsplash.com/photo-1663579170170-169a1ee8b9be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzdHJvbGxlciUyMHVyYmFuJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MDg3MTczMXww&ixlib=rb-4.1.0&q=85",
    alt: "Generic everyday stroller",
  },
  {
    id: "p3",
    label: "Double stroller",
    url: "https://images.unsplash.com/photo-1741990811736-81fd08f449e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxqb2dnaW5nJTIwc3Ryb2xsZXJ8ZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85",
    alt: "Generic double stroller",
  },
  {
    id: "p4",
    label: "Special-use stroller",
    url: "https://images.unsplash.com/photo-1559135141-2bea6465fccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1NzV8MHwxfHNlYXJjaHszfHxiYWJ5JTIwc3Ryb2xsZXJ8ZW58MHx8fHwxNzkwODc5MTkzfDA&ixlib=rb-4.1.0&q=85",
    alt: "Generic special-use stroller",
    position: "center 60%",
  },
];

// V1.3 — Transformation section, studio treatment (V1.3 only)
export const modesDataV13 = [
  {
    id: "bassinet",
    number: "01",
    name: "Bassinet",
    tagline: "Comfort from day one.",
    focus: { x: 62, y: 30, size: 34 },
  },
  {
    id: "single",
    number: "02",
    name: "Single",
    tagline: "Everyday setup.",
    focus: { x: 57, y: 42, size: 32 },
  },
  {
    id: "double",
    number: "03",
    name: "Double",
    tagline: "Ready when one becomes two.",
    focus: { x: 47, y: 54, size: 34 },
  },
  {
    id: "jogger",
    number: "04",
    name: "Jogger",
    tagline: "Built for a faster pace.",
    focus: { x: 68, y: 78, size: 26 },
  },
  {
    id: "wagon",
    number: "05",
    name: "Wagon",
    tagline: "More room for bigger days.",
    focus: { x: 52, y: 68, size: 36 },
  },
];

export const studioProductMedia = {
  url: "/media/strollee-silhouette.png",
  alt: "Strollee S1 studio product view",
};

// V1.3 — Real-life chapter (replaces family selector on V1.3 only)
export const realLifeCopy = {
  eyebrow: "Built for real life",
  headlineLines: ["The all-in-one stroller", "built for real life."],
  support:
    "From daily strolls and naps to growing families, travel and outdoor adventures — one system designed to adapt as life changes.",
  cta: "Explore S1",
};

export const realLifeData = [
  {
    id: "daily",
    label: "Daily Strolls",
    title: "Made for every day.",
    copy: "Neighborhood walks, errands, naps and the normal rhythm of family life.",
    image: {
      url: "/media/real-life-daily.webp",
      alt: "Strollee on a daily city stroll",
    },
  },
  {
    id: "growing",
    label: "Growing Families",
    title: "Ready as life changes.",
    copy: "A system designed to adapt as children, routines and family needs evolve.",
    image: {
      url: "/media/real-life-growing.webp",
      alt: "Strollee with child aboard on a family day out",
    },
  },
  {
    id: "travel",
    label: "Travel Days",
    title: "Made to go with you.",
    copy: "From airports and road trips to days away from home.",
    image: {
      url: "/media/real-life-travel.webp",
      alt: "Strollee out on a travel day",
    },
  },
  {
    id: "active",
    label: "Active Days",
    title: "Keep moving.",
    copy: "Longer walks, faster days and an active family routine.",
    image: {
      url: "/media/real-life-active.webp",
      alt: "Strollee on a long active walk",
    },
  },
  {
    id: "outdoors",
    label: "Outdoor Adventures",
    title: "Ready to go further.",
    copy: "Parks, trails, beach days and weekends beyond the everyday.",
    image: {
      url: "/media/real-life-outdoor.webp",
      alt: "Strollee on an outdoor weekend adventure",
    },
  },
];

// V1.2 selector — per-slide tone + first real studio image (user-provided)
export const scenarioDataV12 = scenarioData.map((s) =>
  s.id === "newborn"
    ? {
        ...s,
        tone: "light",
        image: {
          url: "/media/studio-newborn-cut.webp",
          alt: "Strollee S1 studio shot — single seat configuration",
          fit: "contain",
        },
      }
    : { ...s, tone: "dark" }
);

// Phase 11 — Keep exploring + footer (V1.2)
export const footerData = {
  exploreTitle: "Keep exploring",
  exploreLinks: [
    { id: "s1", title: "Explore S1", desc: "Understand the complete Strollee system.", href: "#s1" },
    { id: "build", title: "Build my Strollee", desc: "Configure your own setup.", href: "#build" },
    { id: "how", title: "How It Works", desc: "See how one system adapts.", href: "#modes" },
    { id: "safety", title: "Safety & Engineering", desc: "Explore the thinking behind Strollee.", href: "#engineering" },
  ],
  newsletter: {
    title: "Stay in the loop",
    copy: "Follow what’s next for Strollee.",
    placeholder: "Email address",
    cta: "Join",
    success: "Thanks — you’re on the list.",
  },
  navGroups: [
    {
      title: "Strollee",
      links: ["Strollee S1", "Ways to Stroll", "Build My Strollee", "Accessories"],
    },
    {
      title: "Discover",
      links: ["How It Works", "Safety & Engineering", "Reviews", "Our Story"],
    },
    {
      title: "Support",
      links: ["Support", "FAQ", "Warranty", "Shipping & Returns", "Contact"],
    },
    {
      title: "Follow",
      links: ["Instagram", "YouTube", "TikTok", "Pinterest"],
    },
  ],
  legal: ["Privacy", "Terms", "Accessibility", "Cookies"],
  copyright: "© 2026 Strollee. Design validation prototype.",
  wordmark: "Strollee",
};

// Phase 10 — Expand your Strollee / ecosystem (V1.2)
export const ecosystemCopy = {
  eyebrow: "The Strollee system",
  headlineLines: ["Built to grow", "beyond day one."],
  support:
    "Add what you need as family life changes — without starting again with another stroller.",
  cardCta: "Explore",
  endCta: "Explore the Strollee system",
};

export const ecosystemItems = [
  {
    id: "for-newborns",
    label: "For newborns",
    title: "Newborn comfort",
    copy: "Bassinet-ready components for the earliest days.",
    image: {
      url: "https://images.unsplash.com/photo-1773672268537-21e349bc7273?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwcmFtJTIwYmFzc2luZXRFZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85",
      alt: "Strollee bassinet components",
      position: "center 70%",
    },
  },
  {
    id: "for-two",
    label: "For two",
    title: "Room for two",
    copy: "Seating additions for when one becomes two.",
    image: {
      url: "https://images.unsplash.com/photo-1741990811736-81fd08f449e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxqb2dnaW5nJTIwc3Ryb2xsZXJ8ZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85",
      alt: "Strollee second-seat additions",
    },
  },
  {
    id: "for-active",
    label: "For active days",
    title: "Faster pace",
    copy: "Components for longer walks and quicker days.",
    image: {
      url: "https://images.unsplash.com/photo-1559135141-2bea6465fccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1NzV8MHwxfHNlYXJjaHszfHxiYWJ5JTIwc3Ryb2xsZXJ8ZW58MHx8fHwxNzkwODc5MTkzfDA&ixlib=rb-4.1.0&q=85",
      alt: "Strollee active-day components",
      position: "center 60%",
    },
  },
  {
    id: "for-travel",
    label: "For travel",
    title: "Pack and go",
    copy: "Pieces that make travelling with the system easier.",
    image: {
      url: "https://images.unsplash.com/photo-1598637349891-151ec358de71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzdHJvbGxlciUyMHVyYmFuJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MDg3MTczMXww&ixlib=rb-4.1.0&q=85",
      alt: "Strollee travel components",
    },
  },
  {
    id: "everyday-extras",
    label: "Everyday extras",
    title: "Daily details",
    copy: "Storage and comfort extras for everyday use.",
    image: {
      url: "https://images.unsplash.com/photo-1590451070514-99799cf0e00a?q=85&w=1920&auto=format&fit=crop",
      alt: "Strollee storage extras",
      filter: "sepia(0.22) saturate(1.15) contrast(1.02)",
    },
  },
];

// Phase 09 — Find My Setup teaser (V1.2)
export const setupCopy = {
  eyebrow: "Guided path",
  headlineLines: ["Find the Strollee", "that fits your family."],
  support:
    "Answer a few simple questions and we’ll guide you toward the setup that makes the most sense for your family today.",
  steps: [
    "How many children?",
    "What stage are they in?",
    "How do you use your stroller most?",
  ],
  resultLabel: "Your recommended setup",
  primaryCta: "Find my setup",
  secondaryHint: "Prefer to configure it yourself?",
  secondaryCta: "Build my Strollee",
};

export const setupMedia = {
  url: "https://images.unsplash.com/photo-1714392512700-4cab9e51710b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxqb2dnaW5nJTIwc3Ryb2xsZXJ8ZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85",
  alt: "Strollee S1 studio configuration",
};

// V1.3 — Find My Setup / guided decision chapter (V1.3 only)
// Role: decision assistance — "Which setup should I start with?" (not lifestyle, not transformation)
export const setupCopyV13 = {
  eyebrow: "Guided path",
  headlineLines: ["Find the Strollee setup", "that fits your family."],
  support:
    "Answer a few simple questions and we’ll point you toward a setup that matches your family, routine and how you plan to use Strollee.",
  steps: [
    "How many children are you strolling with?",
    "What stage are they in?",
    "How will you use Strollee most?",
  ],
  resultLabel: "Your recommended setup",
  primaryCta: "Find my setup",
  secondaryHint: "Prefer to configure it yourself?",
  secondaryCta: "Build my Strollee",
};

// Phase 08 — Families already moving with Strollee (V1.2)
export const communityCopy = {
  eyebrow: "Real life",
  headlineLines: ["Families already", "moving with Strollee."],
  support: "Different families. Different days. One system designed to move with them.",
  quote: "“Loved for everyday versatility.”",
  quoteAttribution: "Placeholder customer quote — real reviews coming soon",
  cta: "See family stories",
};

export const communityMedia = [
  {
    id: "newborn",
    label: "Newborn",
    url: "https://images.unsplash.com/photo-1773672268537-21e349bc7273?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwcmFtJTIwYmFzc2luZXRFZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85",
    alt: "First walks with the Strollee bassinet",
    position: "center 72%",
    span: "col-span-4",
    height: "h-[420px] lg:h-[480px]",
  },
  {
    id: "everyday",
    label: "Everyday",
    url: "https://images.unsplash.com/photo-1663579170170-169a1ee8b9be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzdHJvbGxlciUyMHVyYmFuJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MDg3MTczMXww&ixlib=rb-4.1.0&q=85",
    alt: "City errands with the Strollee",
    span: "col-span-8",
    height: "h-[420px] lg:h-[480px]",
  },
  {
    id: "two-kids",
    label: "Two kids",
    url: "https://images.unsplash.com/photo-1741990811736-81fd08f449e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxqb2dnaW5nJTIwc3Ryb2xsZXJ8ZW58MHx8fHwxNzkwODczNDA1fDA&ixlib=rb-4.1.0&q=85",
    alt: "Two Strollee setups out together",
    span: "col-span-4",
    height: "h-[340px] lg:h-[400px]",
  },
  {
    id: "travel",
    label: "Travel",
    url: "https://images.unsplash.com/photo-1598637349891-151ec358de71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzdHJvbGxlciUyMHVyYmFuJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MDg3MTczMXww&ixlib=rb-4.1.0&q=85",
    alt: "Weekend boardwalk with the Strollee",
    span: "col-span-4",
    height: "h-[340px] lg:h-[400px]",
  },
  {
    id: "active",
    label: "Active",
    url: "https://images.pexels.com/photos/19444952/pexels-photo-19444952.jpeg?auto=compress&cs=tinysrgb&w=1920",
    alt: "Active family day out with the Strollee",
    span: "col-span-4",
    height: "h-[340px] lg:h-[400px]",
  },
];

// Phase 07 — Engineered for what matters. (V1.2)
export const trustCopy = {
  eyebrow: "Built with purpose",
  headlineLines: ["Engineered for", "what matters."],
  support:
    "Thoughtful design, rigorous standards and support built around everyday family life.",
  mediaStatement: ["Designed with", "family life in mind."],
  cta: "Explore engineering",
};

export const trustMedia = {
  url: "https://images.unsplash.com/photo-1785061731364-b2f8b97c2d8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxzdHJvbGxlciUyMHdoZWVsJTIwbWFjcm98ZW58MHx8fHwxNzkwODg2ODIwfDA&ixlib=rb-4.1.0&q=85",
  alt: "Strollee S1 chassis and wheel engineering detail",
};

export const trustPillars = [
  {
    id: "safety",
    number: "01",
    label: "Safety & Testing",
    copy: "Designed around the standards and testing required for everyday family use.",
  },
  {
    id: "materials",
    number: "02",
    label: "Engineering & Materials",
    copy: "Thoughtful construction and materials chosen around durability, comfort and real-world use.",
  },
  {
    id: "warranty",
    number: "03",
    label: "Warranty & Ownership",
    copy: "Clear coverage and long-term ownership support.",
  },
  {
    id: "support",
    number: "04",
    label: "Real Support",
    copy: "Help when you need it — before and after purchase.",
  },
];

// Phase 06 — One stroller. Years of use. (V1.2)
export const longevityCopy = {
  eyebrow: "Built for the long run",
  headlineLines: ["One stroller.", "Years of use."],
  support: "Instead of starting over as life changes, Strollee adapts with your family.",
  oldWayLabel: "The traditional way",
  oldWayCaption: "Five products. One after another.",
  newWayLabel: "The Strollee way",
  newWayCaption: "One system. Every stage.",
  benefits: [
    "Adapts as your family grows",
    "Fewer products to replace",
    "One system you already know",
  ],
  cta: "See how Strollee adapts",
};

// Phase 05 — Built Different (V1.2)
export const builtDifferentCopy = {
  eyebrow: "Why Strollee",
  headlineLines: ["Built different.", "By design."],
  support: "Thoughtful engineering for the details families deal with every day.",
  endCta: "Explore S1",
};

export const featuresData = [
  {
    id: "storage",
    number: "01",
    label: "65L Removable Storage",
    headlineLines: ["More room.", "Less carrying."],
    copy: "A high-capacity storage system designed to come with you, not stay attached to the stroller.",
    image: {
      url: "/media/strollee_65.png",
      alt: "Strollee S1 removable storage system detail",
      filter: "sepia(0.22) saturate(1.15) contrast(1.02)",
    },
  },
  {
    id: "seating",
    number: "02",
    label: "Modular Seating",
    headlineLines: ["Built to change."],
    copy: "Adjust the system as your child, family and daily needs evolve.",
    image: {
      url: "/media/strollee-car.jpg",
      alt: "Strollee S1 modular seat adjustment detail",
    },
  },
  {
    id: "lighting",
    number: "03",
    label: "Integrated Lighting",
    headlineLines: ["Visibility,", "built in."],
    copy: "Lighting integrated directly into the system for changing conditions and everyday movement.",
    image: {
      url: "/media/Strollee-light.png",
      alt: "Strollee S1 integrated lighting detail at dusk",
    },
  },
  {
    id: "audio",
    number: "04",
    label: "Integrated Audio",
    headlineLines: ["More than movement."],
    copy: "Integrated audio designed around the way families spend time together on the move.",
    image: {
      url: "/media/strollee-sound.png",
      alt: "Strollee S1 handlebar and material detail",
    },
  },
];

// Phase 04 — Strollee in Motion (V1.2)
export const motionCopy = {
  eyebrow: "In motion",
  headlineLines: ["Made to move", "with real life."],
  support: "Smooth through the everyday. Ready when the pace changes.",
};

// V1.3 — In Motion statement (scroll-linked word fill)
export const motionStatementV13 = {
  lines: [
    "Smooth where others rattle.",
    "Built to glide. Every path, every pace.",
    "One push. Effortless motion.",
  ],
};


export const motionMedia = {
  videoUrl:
    "https://videos.pexels.com/video-files/6849059/6849059-hd_1920_1080_24fps.mp4",
  posterUrl:
    "https://images.unsplash.com/photo-1758919014355-5dfd705bf6a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzMzN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYWJ5JTIwY2FycmlhZ2UlMjB1cmJhbnxlbnwwfHx8fDE3OTA4NzE3NDd8MA&ixlib=rb-4.1.0&q=85",
  alt: "Strollee S1 moving through everyday family life",
};

// Phase 03 — One stroller. Multiple modes. (physical transformations, V1.2)
export const transformationCopy = {
  eyebrow: "One system",
  headlineLines: ["One stroller.", "Multiple modes."],
  support:
    "From first days to bigger adventures, Strollee transforms as your family’s needs change.",
  endCta: "Explore S1",
};

export const modesData = [
  {
    id: "bassinet",
    number: "01",
    name: "Bassinet",
    tagline: "Comfort from day one.",
    image: {
      url: "/media/stroller-bassinet.png",
      alt: "Strollee S1 in bassinet mode",
      position: "center 72%",
    },
  },
  {
    id: "single",
    number: "02",
    name: "Single",
    tagline: "Your everyday Strollee.",
    image: {
      url: "/media/stroller-single.png",
      alt: "Strollee S1 in single mode",
    },
  },
  {
    id: "double",
    number: "03",
    name: "Double",
    tagline: "Ready when one becomes two.",
    image: {
      url: "/media/stroller-double.png",
      alt: "Strollee S1 in double mode, two seats side by side",
    },
  },
  {
    id: "jogger",
    number: "04",
    name: "Jogger",
    tagline: "Built for a faster pace.",
    image: {
      url: "/media/stroller-jogger.png",
      alt: "Strollee S1 in jogger mode",
    },
  },
  {
    id: "wagon",
    number: "05",
    name: "Wagon",
    tagline: "More room for bigger days.",
    image: {
      url: "/media/stroller-vagon.png",
      alt: "Strollee S1 in wagon mode with room for the whole crew",
    },
  },
];
